module.exports = __webpack_public_path__ + "img/img22.350733f0.svg";